// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#sale-report-create-manually[data-v-6281cc91]  .form-group{margin-bottom:.7rem}#sale-report-create-manually[data-v-6281cc91]  .form-group label{font-size:.9rem;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
